/* =========================================================================
   et-mobile-menu-extra.js - Ela Teila
   GIFT CARD ir LOGIN nuorodos mobiliame meniu.

   Kraunama is snippets/et-scroll-keep.liquid (script eilute failo gale).
   GRAZINIMAS: istrinti ta <script> eilute snippete.

   ---------------------------------------------------------------------
   KODEL JS

   Desktope Gift card ateina is snippets/et-gift-link.liquid - atskiro
   gabaliuko header'yje. Shopify meniuose (main-menu, footer, delivery,
   support, legal) tokios nuorodos nera.

   Mobilus stalcius (snippets/mobile-menu.liquid) sukasi tik per Main menu
   punktus, tad Gift card ten nepatenka. To failo netaisau tiesiogiai:
   7.6 KB, o rasymo kanalas nukerta apie ties 5 KB.

   Pridejus i Shopify Main menu, nuoroda atsirastu ir desktope - butu du
   kartus. Todel darom cia, tik stalciuje. Desktopas nepaliestas.

   ---------------------------------------------------------------------
   VIETOS

   GIFT CARD - po REST bloku, pries FIND YOUR FIT.
   LOGIN     - saraso GALE, po BEHIND IT ALL, su zmogeliuko ikona, kad
               issiskirtu (Ritos sprendimas).

   Ikona paimta ta pati, kuria tema naudoja paskyrai (icon--header-customer).

   Tema paskyros nuoroda deda i stalciaus APACIA, atskirame remelyje
   (.drawer__footer) - ten jos zmogus neranda. Tas apatinis variantas
   paslepiamas per custom-mobile-bd.css.

   Nuoroda /account: patikrinta - nukreipia i Shopify prisijungimo puslapi
   (shopify.com/authentication/.../login).
   ========================================================================= */
(function () {
  var PERSON = '<svg focusable="false" width="18" height="17" class="icon icon--header-customer" viewBox="0 0 18 17" aria-hidden="true"><circle cx="9" cy="5" r="4" fill="none" stroke="currentColor" stroke-width="1" stroke-linejoin="round"></circle><path d="M1 17v0a4 4 0 014-4h8a4 4 0 014 4v0" fill="none" stroke="currentColor" stroke-width="1"></path></svg>';

  function makeItem(cls, href, text, iconHtml) {
    var li = document.createElement('li');
    li.className = 'mobile-nav__item ' + cls;
    li.setAttribute('data-level', '1');
    var a = document.createElement('a');
    a.href = href;
    a.className = 'mobile-nav__link heading h6';
    if (iconHtml) a.innerHTML = iconHtml + '<span>' + text + '</span>';
    else a.textContent = text;
    li.appendChild(a);
    return li;
  }

  function add() {
    var nav = document.querySelector('#mobile-menu-drawer .drawer__content > ul.mobile-nav');
    if (!nav) return;

    var fyf = null;
    var items = nav.children;
    for (var i = 0; i < items.length; i++) {
      var a = items[i].querySelector(':scope > a');
      var fitUrl = (window.etMobileMenu && window.etMobileMenu.fitUrl) || '/pages/find-your-fit';
      if (a && a.getAttribute('href') === fitUrl) { fyf = items[i]; break; }
    }

    if (!nav.querySelector('.et-mobile-gift-link')) {
      var M = window.etMobileMenu || {};
      var gift = makeItem('et-mobile-gift-link', M.giftUrl || '/products/gift-card', M.giftText || 'Gift card', null);
      if (fyf) nav.insertBefore(gift, fyf); else nav.appendChild(gift);
    }

    var old = nav.querySelector('.et-mobile-login-link');
    if (old) old.remove();
    var M2 = window.etMobileMenu || {};
    nav.appendChild(makeItem('et-mobile-login-link', M2.loginUrl || '/account', M2.loginText || 'Login', PERSON));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', add);
  } else {
    add();
  }
  window.addEventListener('load', add);
})();
